import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL = import.meta.env.VITE_BASE_URL;
const CONTACT_FORM_API_URL = `${BASE_URL}/api/public/SubmitForm`;

/**
 * Trimite datele formularului de contact către backend
 * @param {Object} formData - Obiectul cu datele formularului
 * @returns {Promise<Object>} - Răspunsul de la server
 */
export const contactForm = async (formData) => {
  try {
    formData.submittedAt = new Date().toISOString();
    const response = await axios.post(CONTACT_FORM_API_URL, formData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Eroare la trimiterea formularului de contact:', error);
    throw new Error(
      error.response?.data?.message ||
        'A apărut o eroare la trimiterea formularului.',
    );
  }
};

/**
 * Preia conținutul Wiki din backend.
 * @returns {Promise<Array>} - Lista articolelor Wiki.
 */
export const fetchWikiContent = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/public/GetWikiContent`);
    return response.data;
  } catch (error) {
    console.error('Eroare la preluarea conținutului Wiki:', error);
    throw error;
  }
};

/**
 * Abonare la newsletter licitații.
 * @param {Object} data - { name, company, email, phone }
 * @returns {Promise<Object>} { success, message }
 */
export const subscribeToNewsletter = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Newsletter/licitatii`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return {
      success: true,
      message: response.data.message || 'Te-ai abonat cu succes!',
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'A apărut o eroare la abonare.',
    };
  }
};

/**
 * Trimite cererea pentru generarea ofertei tehnice.
 * Datele utilizatorului (FullName, Email, CompanyName, Phone) sunt preluate automat din DB pe backend.
 * @param {string} auctionId - ID-ul licitației
 * @returns {Promise<Object>} { success, message, requestId?, estimatedDelivery?, errorCode? }
 */
export const submitOfferRequest = async (auctionId) => {
  try {
    const token = Cookies.get('jwtToken');

    const headers = { 'Content-Type': 'application/json' };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${BASE_URL}/api/credits/submit-offer-request`,
      {
        AuctionId: String(auctionId),
        RequestType: 'technical_offer',
        UtmSource: 'website',
      },
      { headers },
    );

    return {
      success: true,
      message:
        response.data.message ||
        'Cererea pentru ofertă a fost trimisă cu succes!',
      requestId: response.data.requestId,
      estimatedDelivery: response.data.estimatedDelivery,
    };
  } catch (error) {
    console.error('Eroare la trimiterea cererii pentru ofertă:', error);

    if (error.response?.data) {
      return {
        success: false,
        message:
          error.response.data.message ||
          `Eroare ${error.response.status}: ${error.response.statusText}`,
        errorCode:
          error.response.data.errorCode || `HTTP_${error.response.status}`,
        details:
          error.response.data.details ||
          JSON.stringify(error.response.data, null, 2),
      };
    }

    return {
      success: false,
      message: 'A apărut o eroare de conectare. Vă rugăm să încercați din nou.',
      errorCode: 'NETWORK_ERROR',
      details: error.message,
    };
  }
};

/**
 * Trimite cererea CDE (Common Data Environment) conform ISO SR 19650.
 * @param {string} auctionId - ID-ul licitației
 * @returns {Promise<Object>} { success, message, requestId?, estimatedDelivery?, errorCode? }
 */
export const submitCDERequest = async (auctionId) => {
  try {
    const token = Cookies.get('jwtToken');

    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${BASE_URL}/api/credits/submit-cde-request`,
      { AuctionId: String(auctionId) },
      { headers },
    );

    return {
      success: true,
      message: response.data.message || 'Cererea CDE a fost trimisă cu succes!',
      requestId: response.data.requestId,
      estimatedDelivery: response.data.estimatedDelivery,
    };
  } catch (error) {
    console.error('Eroare la trimiterea cererii CDE:', error);

    if (error.response?.data) {
      return {
        success: false,
        message:
          error.response.data.message ||
          `Eroare ${error.response.status}: ${error.response.statusText}`,
        errorCode:
          error.response.data.errorCode || `HTTP_${error.response.status}`,
      };
    }

    return {
      success: false,
      message: 'A apărut o eroare de conectare. Vă rugăm să încercați din nou.',
      errorCode: 'NETWORK_ERROR',
    };
  }
};
